import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-pagination',
  imports: [
    NgbPagination
  ],
  templateUrl: './pagination.component.html'
})
export class PaginationComponent {

  @Input({required: true}) page!: number;
  @Input({required: true}) recordCount!: number;
  @Input({required: true}) pageSize!: number;
  @Output() pageChange = new EventEmitter<number>();
  @Input() disabled: boolean = false
  protected readonly Math = Math;

  get startEntry(): number {
    return ((this.page - 1) * this.pageSize) + 1;
  }

  get endEntry(): number {
    return Math.min(this.page * this.pageSize, this.recordCount);
  }
  onPageChange(page: number) {
    this.pageChange.emit(page);
  }
}
